import { render, staticRenderFns } from "./UpgradeAccountModal.vue?vue&type=template&id=db53f148&scoped=true"
import script from "./UpgradeAccountModal.vue?vue&type=script&lang=js"
export * from "./UpgradeAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db53f148",
  null
  
)

export default component.exports